import { render } from "./MunicipalityMap.vue?vue&type=template&id=09c3c6c0&scoped=true"
import script from "./MunicipalityMap.vue?vue&type=script&lang=js"
export * from "./MunicipalityMap.vue?vue&type=script&lang=js"

import "./MunicipalityMap.vue?vue&type=style&index=0&id=09c3c6c0&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c3c6c0"]])

export default __exports__